import {
  Col, Form, Input, Radio, Row,
} from 'antd';
import SwitchInput from 'components/SwitchInput';
import React, { useEffect, useMemo } from 'react';
import OrderFormItem from '../../components/OrderFormItem';

function KitchenTip() {
  const form = Form.useFormInstance();
  const merchant = form.getFieldValue('merchant');
  const hasKitchenTip = Form.useWatch('has_kitchen_tip');
  const kitchenTipPercentage = Form.useWatch('kitchen_tip_percentage');
  const has_delivery = form.getFieldValue('has_delivery');
  const isCustomSelected = kitchenTipPercentage === -1 || kitchenTipPercentage === '-1';

  const tipOptions = useMemo(() => {
    if (!merchant) return [5, 10, 15, 20];
    return merchant?.parent?.tip_data?.tip_options || [5, 10, 15, 20];
  }, [merchant]);

  const kitchenTipEnabled = Boolean(
    merchant?.config?.enable_kitchen_tip ?? merchant?.parent?.tip_data?.enable_kitchen_tip,
  );

  useEffect(() => {
    if (kitchenTipPercentage != null && !isCustomSelected) {
      form.setFieldValue('kitchen_tip', undefined);
    }
  }, [kitchenTipPercentage, isCustomSelected, form]);

  useEffect(() => {
    if (!kitchenTipEnabled) {
      form.setFieldValue('has_kitchen_tip', false);
      form.setFieldValue('kitchen_tip_percentage', undefined);
      form.setFieldValue('kitchen_tip', undefined);
    }
  }, [kitchenTipEnabled, form]);

  if (!has_delivery || !kitchenTipEnabled) {
    return null;
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={8} lg={5} className="d-flex align-items-center">
        <OrderFormItem name="has_kitchen_tip" noStyle boolean fullWidth>
          <SwitchInput label="Kitchen tip" direction="horizontal" disabled={!has_delivery} />
        </OrderFormItem>
      </Col>
      <Col xs={24} md={24} lg={19} style={{ display: hasKitchenTip ? 'block' : 'none' }}>
        <OrderFormItem name="kitchen_tip_percentage" noStyle>
          <Radio.Group className="flex flex-col md:flex-row gap-6 md:items-center">
            {tipOptions.map((tip) => (
              <Radio value={tip} key={tip}>
                {tip}
                %
              </Radio>
            ))}
            <Radio value={-1}>
              <OrderFormItem name="kitchen_tip" noStyle>
                <Input
                  disabled={!isCustomSelected}
                  type="number"
                  suffix="$"
                  onFocus={() => {
                    if (!isCustomSelected) {
                      form.setFieldValue('kitchen_tip_percentage', -1);
                    }
                    if (!form.getFieldValue('has_kitchen_tip')) {
                      form.setFieldValue('has_kitchen_tip', true);
                    }
                  }}
                />
              </OrderFormItem>
            </Radio>
          </Radio.Group>
        </OrderFormItem>
      </Col>
    </Row>
  );
}

export default KitchenTip;

